import { TRole } from 'types/roles'

export const filterRolesByAppTypeAndName = (roles: TRole[]) =>
  roles?.filter(
    (userRole) =>
      userRole.appType === null && !userRole.name.toLowerCase().split(' ').includes('oz')
  )
